import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/images/mt.svg'


const _hoisted_1 = { class: "row landing-header justify-between items-center q-mt-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "q-mr-sm"
}, null, -1)
const _hoisted_3 = { class: "mt-text" }
const _hoisted_4 = { class: "column justify-center items-center q-mt-xl q-pt-xl landing-dialog" }
const _hoisted_5 = { class: "dialog__wrapper" }
const _hoisted_6 = { class: "dialog__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_page, { class: "main-container q-layout-container" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "row items-center cursor-pointer masons-logo",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, [
              _hoisted_2,
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('dialogs.endResetpassword.logo')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_form, {
                onSubmit: _ctx.submit,
                class: "column"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('dialogs.endResetpassword.title')), 1),
                  _createVNode(_component_q_input, {
                    outlined: "",
                    "label-color": "white",
                    label: _ctx.$t('dialogs.endResetpassword.labelNew'),
                    onFocus: _ctx.resetErrors,
                    error: _ctx.passwordResetError,
                    modelValue: _ctx.newPassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
                    type: "password"
                  }, null, 8, ["label", "onFocus", "error", "modelValue"]),
                  _createVNode(_component_Button, {
                    centered: "",
                    class: "btn__submit",
                    label: _ctx.$t('dialogs.endResetpassword.changePassword'),
                    type: "submit",
                    loading: _ctx.loading
                  }, null, 8, ["label", "loading"])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}